import * as React from 'react';
import { Link } from 'react-router';
import styled, { css, withTheme } from 'styled-components';
import { rem } from 'polished';
import { DsiItemType as ItemType } from './NavigationItem';
import { DsiSvgIcon, IconType } from '../General/SvgIcon';

export interface Props {
  title: any;
  type?: ItemType;
  theme?: any;
  hoverItems?: any;
  url?: string;
  onClick?: any;
  linkUrl?: string;
}

function MobileNavItem({ title, type, theme, url, onClick, linkUrl }: Props) {
  const loadColorBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return theme.colors.textPrimary;
      }
      case ItemType.SECONDARY: {
        return theme.colors.textPrimary;
      }
      case ItemType.TERTIARY: {
        return theme.colors.textPrimary;
      }
      case ItemType.ACTION: {
        return theme.colors.red;
      }
      default: {
        return theme.colors.primary;
      }
    }
  };

  const loadFontWeightBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return 500;
      }
      case ItemType.SECONDARY: {
        return 500;
      }
      case ItemType.TERTIARY: {
        return 400;
      }
      case ItemType.ACTION: {
        return 500;
      }
      default: {
        return 400;
      }
    }
  };

  const loadDisplayBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return 'inline-block';
      }
      case ItemType.SECONDARY: {
        return 'flex';
      }
      case ItemType.TERTIARY: {
        return 'flex';
      }
      default: {
        return 'inline-block';
      }
    }
  };

  const loadBgColorBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return theme.colors.hover;
      }
      case ItemType.SECONDARY: {
        return theme.colors.hover;
      }
      case ItemType.TERTIARY: {
        return 'transparent';
      }
      default: {
        return theme.colors.hover;
      }
    }
  };

  const color = loadColorBasedOnItemType();
  const fontWeight = loadFontWeightBasedOnItemType();
  const display = loadDisplayBasedOnItemType();
  const backgroundColor = loadBgColorBasedOnItemType();

  if (linkUrl) {
    return (
      <LinkWrapper
        target="_blank"
        href={linkUrl}
        display={display}
        fontWeight={fontWeight}
        color={color}
        onClick={onClick}
        bgColor={backgroundColor}
      >
        {type === ItemType.ACTION && (
          <IconCover>
            <ActionIcon width={16} height={16} icon={IconType.percentage} />
          </IconCover>
        )}
        {title}
      </LinkWrapper>
    );
  }

  return (
    <Wrapper
      to={url}
      display={display}
      fontWeight={fontWeight}
      color={color}
      onClick={onClick}
      bgColor={backgroundColor}
    >
      {type === ItemType.ACTION && (
        <IconCover>
          <ActionIcon width={16} height={16} icon={IconType.percentage} />
        </IconCover>
      )}
      {title}
    </Wrapper>
  );
}

interface WrapperProps {
  color: any;
  fontWeight: any;
  display: string;
  bgColor: string;
}

const linkCss = css`text-decoration: none;
padding: ${rem(18)} ${rem(16)};
color: ${({ color }: WrapperProps) => color};
/* background-color: ${({ bgColor }: WrapperProps) => bgColor}; */
font-weight: ${({ fontWeight }: WrapperProps) => fontWeight};
line-height: ${rem(20)};
font-size: 14px;
border-top: ${({ theme }) => theme.borders.primary};

display: ${({ display }: WrapperProps) => display};
align-items: flex-end;
position: relative;

`;

const LinkWrapper = styled.a`
  ${linkCss}
`;

const Wrapper = styled(Link)`
  ${linkCss}
`;

const IconCover = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.red};
  padding: ${rem(4)};
  border-radius: 50%;
  margin-right: ${rem(8)};
  position: relative;
  top: ${rem(2)};
`;

const ActionIcon = styled(DsiSvgIcon)`
  fill: ${({ theme }) => theme.colors.white};
`;

const withThemeMobileNavItem: any = withTheme(MobileNavItem);
export { withThemeMobileNavItem as MobileNavItem };
